import e from "@firebase/app";

import "@firebase/logger";

import "@firebase/util";

import "@firebase/webchannel-wrapper";

import "tslib";

import { U as r, Z as t, q as a, n as i, z as o, L as s, j as n, W as p, G as c, Y as m, a as f, X as u, e as b, b as l, i as g, r as d, K as h, c as v } from "./prebuilt-30db9a88-9b75cc8d.js";

import { Component as w } from "@firebase/component";

var I = {
    Firestore: r,
    GeoPoint: i,
    Timestamp: o,
    Blob: s,
    Transaction: n,
    WriteBatch: p,
    DocumentReference: c,
    DocumentSnapshot: m,
    Query: f,
    QueryDocumentSnapshot: u,
    QuerySnapshot: b,
    CollectionReference: l,
    FieldPath: g,
    FieldValue: d,
    setLogLevel: h,
    CACHE_SIZE_UNLIMITED: v
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Registers the main Firestore build with the components framework.
 * Persistence can be enabled via `firebase.firestore().enablePersistence()`.
 */
function P(e) {
    !
    /**
 * Configures Firestore as part of the Firebase SDK by calling registerService.
 *
 * @param firebase - The FirebaseNamespace to register Firestore with
 * @param firestoreFactory - A factory function that returns a new Firestore
 *    instance.
 */
    function(e, r) {
        e.INTERNAL.registerComponent(new w("firestore", (function(e) {
            var t = e.getProvider("app").getImmediate();
            return r(t, e.getProvider("auth-internal"));
        }), "PUBLIC" /* PUBLIC */).setServiceProps(Object.assign({}, I)));
    }(e, (function(e, i) {
        return new r(e, new t(e, i), new a);
    })), e.registerVersion("@firebase/firestore", "2.1.2");
}

P(e);

export { P as registerFirestore };
//# sourceMappingURL=index.js.map
